// Utility to clear all authentication data
export const clearAuthData = () => {
  try {
    // Clear all auth-related items from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');

    // Clear any other potential auth-related data
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.includes('token') || key.includes('auth') || key.includes('user'))) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach(key => localStorage.removeItem(key));
  } catch (error) {
    console.error('Failed to clear auth data:', error);
  }
};

// Auto-clear on app startup if tokens are invalid
export const validateAndClearInvalidTokens = () => {
  const accessToken = localStorage.getItem('access_token');

  if (accessToken) {
    try {
      // Check if token is a valid JWT format
      const parts = accessToken.split('.');
      if (parts.length !== 3) {
        clearAuthData();
        return false;
      }

      // Try to decode the payload
      const payload = JSON.parse(atob(parts[1]));
      const exp = payload.exp;

      // Expired access alone is OK if we can still refresh (middleware will renew on first API call)
      if (exp) {
        const now = Date.now() / 1000;
        if (exp < now) {
          if (localStorage.getItem('refresh_token')) {
            return true;
          }
          clearAuthData();
          return false;
        }
      }

      return true;
    } catch {
      clearAuthData();
      return false;
    }
  }

  return false;
};
